import Formulario from "../../../components/Formulario";
import SideBar from "../../../components/SideBar";
import { Main } from "../../styled";
import lixeira_icon from "../../../../assets/icons/lixeira.svg";
import search_icon from "../../../../assets/icons/seach.svg";
import plus_icon from "../../../../assets/icons/plus.svg";
import arrow_back_icon from "../../../../assets/icons/arrow-back.svg";
import Map from "../../../components/Map";
import { Content } from "./styled";
import BuscaEndereco from "../../../components/BuscaEndereco";
import { useState } from "react";
import { useEffect } from "react";
import Select from "../../../components/Select";
import ControllerPlantar, { MIN_PONTOS_AREA } from "./controller";
import { tipoPlantio, tipoProPlantio, estados } from "../../../../utils/data";
import Loading from "../../../components/Loading";
import AlertDialog from "../../../components/AlertDialog";
import DeleteDialog from "../../../components/DeleteDialog";
import Plantio from "../../../../models/Plantio";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteMidiaDialog from "../../../components/DeleteMidiaDialog";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import ModalSolicitarProfissional from "../../../components/ModalSolicitarProfissional";

function Home({ usuario, errors, setErrors }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { plantio_id } = useParams();


  const [mapCenter, setMapCenter] = useState({ lat: -20.3197, lng: -40.3385 });
  const [forceCenter, setForceCenter] = useState(null);

  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [plantio, setPlantio] = useState({ ...Plantio.model });
  const [especies, setEspecies] = useState([]);
  const [nomeEspecie, setNomeEspecie] = useState('');
  const [midiasFile, setMidiasFile] = useState([]);
  const [midiaDelete, setMidiaDelete] = useState(null);
  const [atualizarPlantio, setAtualizarPlantio] = useState(false);
  const [showModalPro, setShowModalPro] = useState(false);

  // Ha ponto marcado, mas a busca automatica nao identificou estado/cidade (servico
  // fora do ar, area rural...). A pessoa completa a mao e consegue salvar.
  const ehArea = plantio.tipo_categoria === 'Profissional';
  const totalPontos = plantio.coordenadas?.length || 0;
  const [confirmarLimpar, setConfirmarLimpar] = useState(false);
  const precisaLocalManual = (plantio.coordenadas?.length || 0) > 0 && (!plantio.estado || !plantio.cidade);

  const controllerPlantar = new ControllerPlantar(plantio, errors, especies, setShowModalPro, midiasFile, setMidiasFile, setPlantio, setErrors, setLoading, setNomeEspecie, setShowSuccess);

  console.log(plantio.especies)
  useEffect(() => {
    controllerPlantar.findAllEspecies(setEspecies);
    controllerPlantar.findPlantio(plantio_id);
    controllerPlantar.getLoacation(setMapCenter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atualizarPlantio, location]);



  // Trocar a categoria (Individual/Profissional) ao REGISTRAR zera endereco,
  // coordenadas e especies, porque o formato dos tres muda. Isso nao pode rodar
  // ao CARREGAR um plantio para edicao: la a categoria passa de vazia para a do
  // plantio e a limpeza apagava tudo o que acabava de ser carregado (mapa sem
  // pins, endereco e especies em branco, e um "Atualizar" que mandaria tudo
  // vazio). Na edicao o select de categoria e desabilitado, entao nao ha troca.
  useEffect(() => {
    if (plantio.tipo_categoria && !plantio.id) {
      setPlantio({
        ...plantio,
        endereco: '',
        coordenadas: [],
        especies: []
      });

      setNomeEspecie('');
    }

  }, [plantio.tipo_categoria]);


  return (
    <SideBar>
      <Main>
        {loading && <Loading titulo={"Aguarde um momento"} subtitulo={"Estamos validando suas informações"} />}

        {showSuccess &&
          <AlertDialog
            titulo={`Plantio ${plantio.id ? 'atualizado' : 'cadastrado'} com sucesso!`}
            buttonText={"Ver plantios"}
            buttonOnClick={() => navigate('/minhas-arvores')}
            secondaryButtonText={plantio.id ? "Continuar editando o plantio" : "Cadastrar novo plantio"}
            secondaryButtonOnclick={plantio.id ? () => setShowSuccess(false) : () => controllerPlantar.limparCampos()}
          />
        }

        {confirmarLimpar &&
          <DeleteDialog
            titulo="Limpar a área?"
            subtitulo="Todos os pontos marcados serão removidos. Você poderá desenhar de novo."
            textButton="Limpar"
            onDelete={() => { controllerPlantar.limparArea(); setConfirmarLimpar(false); }}
            onClose={() => setConfirmarLimpar(false)}
          />
        }

        {showModalPro &&
          <ModalSolicitarProfissional onClose={() => setShowModalPro(false)} />
        }


        {midiaDelete && <DeleteMidiaDialog onDelete={() => controllerPlantar.handleRemoveMidia(midiaDelete, setMidiaDelete)} onClose={() => { setMidiaDelete(null) }} />}

        <Content>
          <section className="left-section">

            {plantio.id &&
              <button className="back" onClick={() => navigate('/minhas-arvores/')}>
                <img src={arrow_back_icon} alt="Icone de voltar" />
                <span> Voltar </span>
              </button>
            }

            <div className="top">
              <h2>Registre sua <span className="primary">Árvore</span></h2>
              <span>Por aqui você pode registrar seu plantio com todos os detalhes que desejar.</span>
            </div>

            <div className="form">
              <Formulario id="form-plantar">
                <div className="form-col">

                  <div className="form-group">
                    <label htmlFor="tipo">Individual ou Profissional</label>
                    <select disabled={plantio.id} id="tipo" name="tipo" placeholder="Individual ou Profissional" required
                      onChange={(e) => controllerPlantar.validarTipoPro(e, usuario.tipo)} className={errors.tipoPro && 'input-error'} value={plantio.tipo_categoria}
                    >
                      <option disabled value={''}>Individual ou Profissional</option>
                      {
                        tipoProPlantio.map(tipo => {
                          return <option key={`tipo-plantio-${tipo}`} value={tipo}>{tipo}</option>
                        })
                      }
                    </select>
                    <span className="error">{errors.tipoPro}</span>
                  </div>

                  <div className="form-group">
                    <label htmlFor="titulo">{`Titulo ${plantio.tipo_categoria === 'Profissional' ? 'da área' : 'do Plantio'}`}</label>
                    <input disabled={!plantio.tipo_categoria} type="text" id="titulo" name="titulo" placeholder={`Insira o titulo ${plantio.tipo_categoria === 'Profissional' ? 'da área' : 'do Plantio'}`} required
                      value={plantio.titulo} onChange={(e) => controllerPlantar.validarTitulo(e)} className={errors.titulo && 'input-error'}
                    />
                    <span className="error">{errors.titulo}</span>
                  </div>

                  <div className="form-group">
                    <label htmlFor="endereco">{`Localizão ${plantio.tipo_categoria === 'Profissional' ? 'da área' : 'do Plantio'}`}</label>
                    <BuscaEndereco
                      value={plantio.endereco}
                      onChange={(texto) => controllerPlantar.validarLocalizacao(texto)}
                      onSelect={(resultado) => controllerPlantar.validarSelectLocalizacao(resultado, setForceCenter)}
                      placeholder={`Insira a localização ${plantio.tipo_categoria === 'Profissional' ? 'da área' : 'do Plantio'}`}
                      className={`input-prefix ${errors.endereco && 'input-error'}`}
                      disabled={!plantio.tipo_categoria}
                    />
                    <img className="prefix" src={search_icon} alt="Icone de busca" />
                    <div className="coordenadas-list">
                      {plantio.coordenadas?.map((coordenada, index) => {
                        return coordenada.end ?
                          <></> :
                          <div className="coordenadas" key={`coordenada-${index}`}>
                            Coordenadas {index + 1}: <span>{parseFloat(coordenada.lat)}, {parseFloat(coordenada.lng)}</span>
                            {/* Alternativa por teclado/toque ao botão direito no mapa. */}
                            {ehArea &&
                              <>
                                <button type="button" className="remover-ponto" aria-label={`Remover o ponto ${index + 1}`} onClick={() => controllerPlantar.removerPonto(index)}>Remover</button>
                                {/* Só com a área já formada (3+ pontos): antes disso o clique no mapa acrescenta. */}
                                {totalPontos >= MIN_PONTOS_AREA &&
                                  <button type="button" className="inserir-ponto" aria-label={`Acrescentar um ponto depois do ponto ${index + 1}`} onClick={() => controllerPlantar.inserirPontoNoMeio(index)}>+ Ponto</button>
                                }
                              </>
                            }
                          </div>
                      })}
                    </div>

                    {ehArea &&
                      <div className="edicao-pontos" role="group" aria-label="Edição dos pontos da área">
                        <p className="ajuda-pontos">
                          Arraste um ponto para movê-lo · botão direito num ponto para removê-lo
                          {/* Área já fechada (edição) não aceita pontos novos, a menos que fique com menos de 3. */}
                          {(!plantio_id || totalPontos < MIN_PONTOS_AREA) && " · clique no mapa para adicionar · duplo clique para finalizar"}
                          {totalPontos >= MIN_PONTOS_AREA && " · com a área fechada, clique no “+” no meio de um lado (ou em “+ Ponto” na lista) para acrescentar uma ponta"}
                        </p>
                        {totalPontos > 0 &&
                          <div className="botoes-pontos">
                            <button type="button" onClick={() => controllerPlantar.desfazerUltimoPonto()}>Desfazer último ponto</button>
                            <button type="button" className="perigo" onClick={() => setConfirmarLimpar(true)}>Limpar área</button>
                          </div>
                        }
                        {totalPontos > 0 && totalPontos < MIN_PONTOS_AREA &&
                          <span className="aviso-pontos" role="status">
                            A área precisa de pelo menos {MIN_PONTOS_AREA} pontos (tem {totalPontos}). Clique no mapa para marcar mais.
                          </span>
                        }
                      </div>
                    }
                    <span className="error">{errors.endereco}</span>

                    {precisaLocalManual &&
                      <div className="local-manual" role="group" aria-label="Estado e cidade do plantio" style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <label htmlFor="estado-manual">Estado</label>
                        <select id="estado-manual" style={{ width: "100%" }} value={plantio.estado || ''} onChange={(e) => controllerPlantar.validarEstadoManual(e.target.value)} className={errors.estado && 'input-error'}>
                          <option value="">Selecione o estado</option>
                          {estados.map((estado) => <option key={`estado-${estado}`} value={estado}>{estado}</option>)}
                        </select>
                        <span className="error">{errors.estado}</span>

                        <label htmlFor="cidade-manual">Cidade</label>
                        <input id="cidade-manual" type="text" style={{ width: "100%" }} placeholder="Informe a cidade" value={plantio.cidade || ''} onChange={(e) => controllerPlantar.validarCidadeManual(e.target.value)} className={errors.cidade && 'input-error'} />
                        <span className="error">{errors.cidade}</span>
                      </div>
                    }
                  </div>

                  <div className="form-group">
                    <label htmlFor="especie">{`${plantio.tipo_categoria === 'Profissional' ? 'Espécies' : 'Espécie'}`}</label>
                    <Select
                      id="especies"
                      name="especies"
                      placeholder={`Selecione ${plantio.tipo_categoria === 'Profissional' ? 'as espécies' : 'uma espécie'}`}
                      required
                      autoComplete="off"
                      value={nomeEspecie}
                      onChange={(e) => controllerPlantar.filtrarEspecies(e, setEspecies)}
                      className={`input-prefix ${errors.especies && 'input-error'}`}
                      options={especies.rows}
                      onClickOption={(especie) => controllerPlantar.onClickSelectEspecie(especie)}
                      showOptions={showOptions}
                      setShowOptions={setShowOptions}
                      disabled={!plantio.tipo_categoria}
                      selecteds={plantio.especies}
                      closeOnSelect={plantio.tipo_categoria !== 'Profissional'}
                    />
                    <span className="error">{errors.especies}</span>
                    <div className="especies-container">
                      {plantio.especies.map((especieItem, index) => (
                        <div className="especie-item">
                          <span className="nome-especie">{`${especieItem?.especie?.nome_comum || especieItem?.especie?.nome_cientifico}`}</span>
                          <div className="especies-count">
                            <span onClick={() => controllerPlantar.handleRemoveCountMudas(index)}> - </span>
                            <input value={especieItem.numero_mudas} onChange={(e) => controllerPlantar.handleChangeCountMudas(e, index)} />
                            <span onClick={() => controllerPlantar.handleAddCountMudas(index)}> + </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="tipo">Tipo de plantio</label>
                    <select disabled={!plantio.tipo_categoria} id="tipo" name="tipo" placeholder="Selecione o tipo de plantio" required
                      onChange={(e) => controllerPlantar.validarTipo(e)} className={errors.tipo && 'input-error'} value={plantio.tipo}
                    >
                      <option disabled value={''}>Selecione o tipo de plantio</option>
                      {
                        tipoPlantio.map(tipo => {
                          return <option key={`tipo-plantio-${tipo}`} value={tipo}>{tipo}</option>
                        })
                      }
                    </select>
                    <span className="error">{errors.tipo}</span>
                  </div>
                  {
                    (plantio.tipo && plantio.tipo !== 'Pessoal') &&
                    <div className="form-group">
                      <label htmlFor="nome_organizacao">Nome da {plantio.tipo === "Organizacional" ? 'organização' : 'empresa'}</label>
                      <input type="text" id="nome_organizacao" name="nome_organizacao" placeholder="Insira o nome da organização" required
                        value={plantio.nome_organizacao} onChange={(e) => controllerPlantar.validarOrganizacao(e)} className={errors.nome_organizacao && 'input-error'}
                      />
                      <span className="error">{errors.nome_organizacao}</span>
                    </div>
                  }


                  <div className="form-group">
                    <label>Adicionar fotos/videos</label>
                    <input disabled={!plantio.tipo_categoria} id="midias" type="file" name="midias" accept="image/*,video/mp4" multiple required={!plantio.id} onChange={(e) => controllerPlantar.handleChangeMidia(e)} />
                    <div className="midias">
                      {
                        plantio.midias.map(midia => (
                          <label key={`midia-plantio-${midia.id}`}>
                            <div className="image">
                              {midia.tipo === 'Imagem' ? (
                                <img className="preview-image" src={midia.path} alt="Preview" />
                              ) : (
                                <video className="preview-video" src={midia.path} controls />
                              )}
                              <div className="blur"
                                onClick={() => controllerPlantar.handleDeleteMidia(midia, setMidiaDelete)}
                              >
                                <div className="blur-bg"></div>
                                <img src={lixeira_icon} alt="Icone de Lixeira" />
                              </div>

                            </div>
                          </label>
                        ))
                      }

                      {
                        midiasFile.map((file, index) => (
                          <label key={`midias-added-${index}`}>
                            <div className="image">
                              {file.type.includes('image') ? (
                                <img className="preview-image" src={URL.createObjectURL(file)} alt="Preview" />
                              ) : (
                                <video className="preview-video" src={URL.createObjectURL(file)} controls />
                              )}
                              <div className="blur"
                                onClick={() => controllerPlantar.handleDeleteMidia(file, setMidiaDelete)}
                              >
                                <div className="blur-bg"></div>
                                <img src={lixeira_icon} alt="Icone de Lixeira" />
                              </div>

                            </div>
                          </label>
                        )
                        )}

                      {controllerPlantar.validarMidias(plantio.midias, midiasFile, 4) &&
                        <label htmlFor="midias">
                          <div className={`image ${errors.midias && 'image-error'}`} onClick={() => setErrors({ ...errors, midias: "" })}>
                            <img className="plus-icon" src={plus_icon} alt="Iocne de adicionar" />
                          </div>

                        </label>
                      }

                    </div>
                    <span className="error">{errors.midias}</span>
                  </div>
                </div>

                <div className="form-group">
                  <button type="submit" onClick={(e) => controllerPlantar.handleSubmit(e, usuario.id, setAtualizarPlantio, atualizarPlantio, !!plantio.id)}>{plantio.id ? "Atualizar" : "Registrar"} Plantio</button>
                  <span className="error">{errors.geral}</span>
                </div>
              </Formulario>
            </div>

          </section>

          <section className="right-section">
            <Map
              isPro={plantio.tipo_categoria === 'Profissional'}
              isEndArea={!!plantio_id}
              markers={plantio.coordenadas}
              mapCenter={{ lat: parseFloat(plantio.lat) || mapCenter.lat, lng: parseFloat(plantio.lng) || mapCenter.lng }}
              onClick={(e) => controllerPlantar.validarClickLocalizacao(e, plantio.tipo_categoria === 'Profissional')}
              onMarkerDragEnd={(markerIndex, latLng) => controllerPlantar.handleOnDrag(markerIndex, latLng)}
              onMarkerRemove={(markerIndex) => controllerPlantar.removerPonto(markerIndex)}
              onMarkerInsert={(depois, latLng) => controllerPlantar.inserirPonto(depois, latLng)}
              onCloseArea={() => controllerPlantar.handleCloseArea()}
              forceCenter={forceCenter}
              plantio={!!plantio_id}
            />
          </section>
        </Content>
      </Main>
    </SideBar>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);